import { Reveal, Overline } from "@/components/Reveal";
import { Check } from "lucide-react";

const STUDENTS_IMG = "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/78a2b12e8c5f8b3f037daff03697ad277125c29250284a0fa6506d25bcf2e371.png";

const ITEMS = [
  ["Más de 800 programas listos para vender", "Cursos, diplomados, especializaciones y certificaciones de educación continua, sin necesidad de desarrollar contenido propio."],
  ["Programas académicos con validez oficial", "Licenciaturas, maestrías y doctorados respaldados por instituciones universitarias acreditadas, algo que normalmente toma años y millones de pesos construir desde cero."],
  ["Generación de demanda activa", "Campañas publicitarias centrales, red de afiliados y agencias de marketing trabajando de forma continua para nutrir de prospectos a cada franquiciatario."],
  ["Capacitación del equipo comercial", "Entrenamiento estructurado para que el equipo de ventas del franquiciatario convierta con consistencia."],
  ["Soporte operativo constante", "La central de Kairós Learning acompaña la operación en todo momento, no solo en el arranque."],
];

export function FranchiseSystem() {
  return (
    <section id="sistema" data-testid="sistema-section" className="relative py-24 sm:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline>El sistema de franquicia</Overline>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.1]">
                Un ecosistema educativo completo, ya validado en el mercado.
              </h2>
              <p className="font-sans text-lg font-light text-midnight/70 mt-6 max-w-2xl">
                Operar bajo Kairós Learning significa acceder a un territorio definido y a una operación que ya funciona:
              </p>
            </Reveal>

            <div className="mt-10 space-y-px bg-midnight/10 border border-midnight/10">
              {ITEMS.map(([title, desc], i) => (
                <Reveal key={title} delay={i * 0.07} className="bg-ivory">
                  <div className="p-6 flex gap-4">
                    <div className="shrink-0 w-9 h-9 bg-crimson flex items-center justify-center">
                      <Check className="w-5 h-5 text-ivory" strokeWidth={2.5} />
                    </div>
                    <div>
                      <h3 className="font-serif text-lg sm:text-xl font-semibold text-midnight">{title}</h3>
                      <p className="font-sans text-sm font-light text-midnight/60 mt-1 leading-relaxed">{desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1}>
              <p className="font-sans text-base font-light text-midnight/70 mt-8 max-w-2xl border-l-2 border-crimson pl-5">
                El franquiciatario no construye un negocio educativo desde los cimientos. Entra a un sistema que ya
                funciona y lo hace crecer en su territorio.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="relative">
              <img src={STUDENTS_IMG} alt="Estudiantes tomando clases en línea" className="w-full h-[620px] object-cover" />
              <div className="absolute inset-0 ring-1 ring-inset ring-midnight/10" />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/50 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
